<script setup></script>

<template v-if="content">
    <div class="container grid pb-10 lg:pt-4 xl:grid-cols-6 xl:pt-15">
        <div class="xl:col-span-4 xl:col-start-2">
            <slot />
        </div>
    </div>
</template>
